export type EditKeysType =
    | 'NAME'
    | 'PHONE'
    | 'SKLADON_USER'
    | 'SURNAME'
    | 'USER_EMAIL'
    | 'roles'
    | 'USER_PROVIDERS';

export const EDIT_KEYS = [
    'NAME',
    'PHONE',
    'SKLADON_USER',
    'SURNAME',
    'USER_EMAIL',
    'roles',
    'USER_PROVIDERS',
];

export const STORAGE_KEY = 'userEditData';
